import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import AboutUsLanding from "../views/AboutUsLanding";

export default function AboutUs() {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	useEffect(() => {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			setView(<AboutUsLanding/>);
		} else {
			setView(null);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}
